import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M8.3 12l6 6 1.4-1.4-4.6-4.6 4.6-4.6L14.3 6l-6 6z" }));
export {
  o as ReactComponent
};
